export default "__VITE_ASSET__DdDx38IE__"